/* eslint-disable max-len */
import React from 'react';

export const Ellipse = () => (
  <svg className="preview-working__ellipse" width="1440" height="903" viewBox="0 0 1440 903" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_174_32)">
      <path d="M1450.94 469.351C1450.94 515.698 1391.65 623 958.5 623C743.664 623 539.752 478.924 354 469.351C165.238 459.622 -117.644 492.711 -117.644 469.351C-117.644 434.894 76.4324 405.288 354 392.365C449.788 387.905 607.87 280.5 719 280.5C941.369 280.5 986.498 405.956 1232.5 411.242C1367.79 426.321 1450.94 446.797 1450.94 469.351Z" fill="url(#paint0_linear_174_32)" fillOpacity="0.3" />
    </g>
    <defs>
      <filter id="filter0_f_174_32" x="-397.644" y="0.5" width="2128.59" height="902.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="140" result="effect1_foregroundBlur_174_32" />
      </filter>
      <linearGradient id="paint0_linear_174_32" x1="318" y1="490.5" x2="1363.5" y2="570.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ADFF5B" />
        <stop offset="1" stopColor="#5BFFFF" />
      </linearGradient>
    </defs>
  </svg>

);
